import { BUSINESS, WA_DEFAULT_MSG } from "@/constants/business";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 lg:py-32 bg-[var(--tt-green-900)] text-[var(--tt-cream)] relative overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-50" />
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full bg-[var(--tt-orange)] opacity-[0.08] blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-[var(--tt-orange)]">
            İletişim
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl mt-4 leading-[1.02]">
            Bize ulaşın, kapımız her zaman açık.
          </h2>
          <p className="text-[var(--tt-cream)]/75 mt-6 max-w-md">
            WhatsApp üzerinden hızlıca yazabilir, telefonla doğrudan arayabilir veya
            dükkanımıza uğrayabilirsiniz.
          </p>

          <div className="mt-10 space-y-5">
            {/* Address */}
            <a
              href={BUSINESS.mapsLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-address-link"
              className="group flex items-start gap-4 rounded-2xl bg-white/5 border border-white/10 p-5 hover:bg-white/10 transition-colors"
            >
              <span className="shrink-0 w-11 h-11 rounded-xl bg-[var(--tt-orange)]/15 text-[var(--tt-orange)] flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>
              <div>
                <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-[var(--tt-cream)]/60">Adres</div>
                <div className="text-base font-bold mt-0.5">{BUSINESS.city}</div>
                <div className="text-sm text-[var(--tt-cream)]/75 mt-1">{BUSINESS.address}</div>
              </div>
            </a>

            {/* Phones */}
            {BUSINESS.phones.map((p, i) => (
              <div
                key={p.whatsapp}
                data-testid={`contact-phone-row-${i + 1}`}
                className="flex items-stretch gap-3 rounded-2xl bg-white/5 border border-white/10 p-3"
              >
                <div className="flex items-center gap-4 px-3 flex-1">
                  <span className="shrink-0 w-11 h-11 rounded-xl bg-white/10 flex items-center justify-center">
                    <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
                    </svg>
                  </span>
                  <div>
                    <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-[var(--tt-cream)]/60">{p.label}</div>
                    <a href={`tel:${p.tel}`} className="text-lg font-bold hover:text-[var(--tt-orange)] transition-colors" data-testid={`contact-phone-${i + 1}`}>
                      {p.display}
                    </a>
                  </div>
                </div>
                <a
                  data-testid={`contact-whatsapp-${i + 1}`}
                  href={`https://wa.me/${p.whatsapp}?text=${encodeURIComponent(WA_DEFAULT_MSG)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`WhatsApp ${p.display}`}
                  className="shrink-0 flex items-center justify-center px-4 rounded-xl bg-[#25D366] hover:bg-[#1ebe57] text-white transition-colors"
                >
                  <svg viewBox="0 0 32 32" className="w-5 h-5 fill-current" aria-hidden="true">
                    <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.788 2.722.788.817 0 2.15-.515 2.45-1.318.158-.43.158-.802.115-.93-.072-.214-.387-.33-.616-.45-.703-.348-1.575-.83-1.875-.83zM16 7.105a8.95 8.95 0 0 0-7.6 13.62L7.2 25l4.4-1.16A8.95 8.95 0 1 0 16 7.105z" />
                  </svg>
                </a>
              </div>
            ))}

            {/* Hours */}
            <div className="flex items-center gap-4 rounded-2xl bg-white/5 border border-white/10 p-5">
              <span className="shrink-0 w-11 h-11 rounded-xl bg-[var(--tt-green-500)]/20 text-[var(--tt-green-500)] flex items-center justify-center">
                <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12 6 12 12 16 14" />
                </svg>
              </span>
              <div>
                <div className="text-[11px] uppercase tracking-[0.18em] font-bold text-[var(--tt-cream)]/60">Çalışma Saatleri</div>
                <div className="text-base font-bold mt-0.5">Pzt - Cmt • 08:00 - 19:00</div>
              </div>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="lg:col-span-7">
          <div className="relative rounded-3xl overflow-hidden border border-white/10 shadow-2xl h-[480px] sm:h-[560px] lg:h-full">
            <iframe
              data-testid="contact-map"
              title="Tuncay Ticaret konumu"
              src={BUSINESS.mapsEmbed}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "480px" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
